import { render, staticRenderFns } from "./singleScope.vue?vue&type=template&id=b3ae7dcc&scoped=true&"
import script from "./singleScope.vue?vue&type=script&lang=js&"
export * from "./singleScope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ae7dcc",
  null
  
)

export default component.exports